import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, checking } = useAuth();
  const location = useLocation();

  if (checking) {
    return (
      <div className="min-h-screen grid place-items-center bg-zinc-950" data-testid="auth-checking">
        <div className="flex flex-col items-center gap-3">
          <div className="h-2 w-24 bg-zinc-800 rounded overflow-hidden">
            <div className="h-full w-1/2 bg-[#F5A623] animate-pulse" />
          </div>
          <span className="text-xs tracking-[0.25em] uppercase text-zinc-500">Authenticating</span>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;

  return children;
}
